<template>
  <div
    class="c-tab"
    :class="[classes ? classes : '']"
  >
    <ul class="c-tab-list">
      <li
        class="c-tab-list__item"
        :class="[classes ? classes : '', {'is-active': current == 'region'}]"
        @click="onSelect('region')"
      >
        地域別
      </li>
      <li
        class="c-tab-list__item"
        :class="[classes ? classes : '', {'is-active': current == 'prefecture'}]"
        @click="onSelect('prefecture')"
      >
        都道府県別
      </li>
    </ul>
  </div>

</template>

<script>
export default {
  props: {
    classes: { type: String, required: false },
    current: { type: String, required: true },
    onSelect: { type: Function, required: true },
  },
  data() {
    return {
      activeTab: this.current,
    }
  },
  methods: {},
}
</script>
